import React from "react";

const success = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			d="M21.2927 12.2212L15 18.3654L11.0481 14.4135L9.72116 15.7404L14.3365 20.3558L15 20.9904L15.6635 20.3558L22.5 13.5L21.2927 12.2212Z"
			fill="#499149"
		/>
		<circle cx="16" cy="16" r="11" stroke="#499149" strokeWidth="2" />
	</svg>
);

const warning = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			d="M16 4C9.38281 4 4 9.38281 4 16C4 22.6172 9.38281 28 16 28C22.6172 28 28 22.6172 28 16C28 9.38281 22.6172 4 16 4ZM16 6C21.5352 6 26 10.4648 26 16C26 21.5352 21.5352 26 16 26C10.4648 26 6 21.5352 6 16C6 10.4648 10.4648 6 16 6ZM15 10V18H17V10H15ZM15 20V22H17V20H15Z"
			fill="#EAA800"
		/>
	</svg>
);

const error = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			d="M16 3.21875L15.125 4.71875L3.125 25.5L2.28125 27H29.7188L28.875 25.5L16.875 4.71875L16 3.21875ZM16 7.21875L26.25 25H5.75L16 7.21875ZM15 14V20H17V14H15ZM15 21V23H17V21H15Z"
			fill="#B40B20"
		/>
	</svg>
);

const info = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			d="M16 4C9.38341 4 4 9.38341 4 16C4 22.6166 9.38341 28 16 28C22.6166 28 28 22.6166 28 16C28 9.38341 22.6166 4 16 4ZM16 5.84615C21.6178 5.84615 26.1538 10.3822 26.1538 16C26.1538 21.6178 21.6178 26.1538 16 26.1538C10.3822 26.1538 5.84615 21.6178 5.84615 16C5.84615 10.3822 10.3822 5.84615 16 5.84615ZM15.0769 10.4615V12.3077H16.9231V10.4615H15.0769ZM15.0769 14.1538V21.5385H16.9231V14.1538H15.0769Z"
			fill="#477894"
		/>
	</svg>
);

export { success, warning, error, info };
